import { FC, FormHTMLAttributes, ReactNode } from 'react';

interface RequestDemoFormElementProps extends FormHTMLAttributes<HTMLFormElement> {
  children: ReactNode;
}

const RequestDemoFormElement: FC<RequestDemoFormElementProps> = ({ children, ...props }) => {
  /*
   * to duplicate the previous StyledComponents implementation - styling the <label> elements here 
   * TODO: if all labels are styled this way, we should update the InputFieldLabel
   */
  return <form className='flex flex-col gap-3
      [&_label]:text-[12px]
      [&_label]:line-height-[13px]
      [&_label]:font-weight-600 
    [&_label]:text-black'
    {...props}>{children}</form>;
};

export default RequestDemoFormElement;
